module.exports = __webpack_public_path__ + "img/omar-rodriguez-XYuNwlYtfLI-unsplash.3aeb51cb.jpg";